import tw, { styled } from 'twin.macro';

const FullscreenControl = styled.div`
  ${tw`absolute left-0`}
  top: 36px;
  padding: 10px;
`;

export default FullscreenControl;
